import React from 'react';
import Anim from '../../assets/gif/animation.gif';

const Animation = () => {
    return(
        <div className="animation-div">
        <img src={Anim} alt="loader"/>
        </div>
    );
}

export default Animation;
